<template>
  <LayoutTelas
    id="tela__financas"
    :titulo="this.$route.meta.titulo"
    :isLoading="isLoading">

    <div class='financeiro'>
      <loading :active.sync='isLoading' :can-cancel='false' :is-full-page='true' />
        <BForm class="financeiro__filtro">
          <BButtonGroup class='btngroup'>
            <BButton @click.prevent='butauHoje'>Hoje</BButton>
            <BButton @click.prevent='butau7dias'>7 Dias</BButton>
            <BButton @click.prevent='butau30'>Mês</BButton>
          </BButtonGroup>
          <InputBasico
            type='date'
            label='Data inicial'
            name='dataInicial'
            class='dataInicial'
            v-model='form.dataInicial'
            v-validate="'required'"
            :errorsBag='errors'
          />

          <InputBasico
            type='date'
            label='Data final'
            name='dataFinal'
            class='dataFinal'
            v-model='form.dataFinal'
            v-validate="'required'"
            :errorsBag='errors'
          />
          <BButton variant='primary' class="btnPesquisar"
            @click.prevent='butauPesquisar'>
            Pesquisar</BButton>
        </BForm>

      <div class='financeiro__body'>
        <BarChart v-if='this.filiais.length > 0' :chartdata='graficoFiliais' :key='idkey' />
      </div>
    </div>
  </LayoutTelas>
</template>

<script>
import { BForm, BButton, BButtonGroup } from 'bootstrap-vue/es/components';
import GeradorMensagens from '@/mixins/GeradorMensagens';
import InputBasico from '@/components/inputs/InputBasico.vue'

import faturamentoService from '../../services/faturamento.service';
import filiaisService from '../../services/filiais.service';

import BarChart from '@/components/graficos/BarChart';

export default {
  name: 'Financas',
  mixins: [GeradorMensagens],
  components: {
    BForm,
    BButton,
    BButtonGroup,
    BarChart,
    InputBasico,
  },
  data() {
    return {
      isLoading: false,
      faturamentos: {},
      form: this.retornaValoresIniciaisForm(),
      filiais: [],
      idkey: 0,
    };
  },
  computed: {
    graficoFiliais: function () {
      const ax = this.filiais.map(filial => filial.nome);
      return {
        labels: ax,
        datasets: this.faturamentos,
      }
    },
  },
  async mounted() {
    await this.retornaFiliais();
    await this.buscarFaturamentos30()
  },
  methods: {
    retornaValoresIniciaisForm() {
      return {
        filial: '',
        dataInicial: '',
        dataFinal: '',
      };
    },
    async buscarFaturamentos(dataInicial, dataFinal) {
      try {
        this.mostrarLoader();
        const filtro = {
          dataInicial: dataInicial,
          dataFinal: dataFinal,
        }
        this.faturamentos = await faturamentoService.retornaFaturamentos(
          filtro,
        );
        this.faturamentos = this.carregaDataSets();
        this.idkey += 1;
      } catch (error) {
        this.tratarRespostaMsg(error);
      } finally {
        this.mostrarLoader(false);
      }
    },
    async buscarFaturamentos30(filtro) {
      try {
        this.mostrarLoader();
        this.faturamentos = await faturamentoService.retornaFaturamentos30(
          filtro,
        );
        this.faturamentos = this.carregaDataSets();
        this.idkey += 1;
      } catch (error) {
        this.tratarRespostaMsg(error);
      } finally {
        this.mostrarLoader(false);
      }
    },
    async buscarFaturamentos7(filtro) {
      try {
        this.mostrarLoader();
        this.faturamentos = await faturamentoService.retornaFaturamentos7dias(
          filtro,
        );
        this.faturamentos = this.carregaDataSets();
        this.idkey += 1;
      } catch (error) {
        this.tratarRespostaMsg(error);
      } finally {
        this.mostrarLoader(false);
      }
    },
    async buscarFaturamentosHoje(filtro) {
      try {
        this.mostrarLoader();
        this.faturamentos = await faturamentoService.retornaFaturamentosHoje(
          filtro,
        );
        this.faturamentos = this.carregaDataSets();
        this.idkey += 1;
      } catch (error) {
        this.tratarRespostaMsg(error);
      } finally {
        this.mostrarLoader(false);
      }
    },
    carregaPorEmpresa() {
      const retBruto = {
        label: 'Total bruto',
        backgroundColor: '#1e88e5',
        data: [],
      };
      const retFuncionarios = {
        label: 'Total funcionários',
        backgroundColor: '#fb8c00',
        data: [],
      };
      const retLiquido = {
        label: 'Total liquido',
        backgroundColor: '#43a047',
        data: [],
      };
      const retAtendimento = {
        label: 'Qnt. Atendimentos',
        backgroundColor: '#5e35b1',
        data: [],
      };
      this.filiais.forEach(filial => {
        const ret = this.faturamentos.filter(faturamento => faturamento._id === filial._id)[0]
        if (ret) {
          retBruto.data.push(ret.totalBruto.toFixed(2));
          retFuncionarios.data.push(ret.totalFuncionario.toFixed(2));
          retLiquido.data.push(ret.totalLiquido.toFixed(2));
          retAtendimento.data.push(ret.atendimentos);
        } else {
          retBruto.data.push(0);
          retFuncionarios.data.push(0);
          retLiquido.data.push(0);
          retAtendimento.data.push(0);
        }
      });
      const retorno = [];
      retorno.push(retBruto, retFuncionarios, retLiquido, retAtendimento);
      return retorno;
    },
    carregaDataSets() {
      return this.carregaPorEmpresa();
    },
    mostrarLoader(mostrar = true) {
      this.isLoading = mostrar;
    },
    butauHoje() {
      this.buscarFaturamentosHoje();
    },
    butau7dias() {
      this.buscarFaturamentos7();
    },
    butau30() {
      this.buscarFaturamentos30();
    },
    butauPesquisar() {
      this.buscarFaturamentos(this.form.dataInicial, this.form.dataFinal);
    },
    async retornaFiliais() {
      try {
        this.mostrarLoader();
        const retorno = await filiaisService.retornaTodos();
        this.filiais = retorno.lista;
      } catch (error) {
        this.tratarRespostaMsg(error);
      } finally {
        this.mostrarLoader(false);
      }
    },
  },
};
</script>

<style lang='scss' scoped>
@import '@/scss/breakpoints.scss';

.financeiro {
  // background-color: red;
  display: flex;
  flex-direction: column;
  max-width: 100%;

  &__filtro {
    display: grid;
    grid-template-columns: 1fr;

    @media (min-width: $small-size) {
      width: 100%;
      grid-template-columns: repeat(12, 1fr);
      grid-column-gap: 0.8em;
    }

    @media (min-width: $extra-large-size) {
      width: $medium-size;
    }
  }

  &__body {
    // background-color: green;
    // width: 100%;
    @media (min-width: $small-size) {
      grid-column: 1 / -1;
    }
  }
}

.btngroup {
  @media (min-width: $small-size) {
    grid-column: 1 / -1;
  }

  @media (min-width: $medium-size) {
    grid-column: 1 / 5;
  }
}

.dataInicial {
  @media (min-width: $small-size) {
    grid-column: 1 / -1;
  }

  @media (min-width: $medium-size) {
    grid-column: 1 / 4;
  }
}
.dataFinal {
  @media (min-width: $small-size) {
    grid-column: 1 / -1;
  }

  @media (min-width: $medium-size) {
    grid-column: 4 / 7;
  }
}

.btnPesquisar {
  @media (min-width: $small-size) {
    grid-column: 1 / -1;
  }

  @media (min-width: $medium-size) {
    margin-bottom: 1em;
    margin-top: 1.85em;
    grid-column: 7 / 9;
  }
}

#tela__financas {
  display: flex;
  flex-direction: column;
  max-width: 100%;

  @media (min-width: $medium-size) {
    min-width: $small-size;
  }
}
</style>
